<template>
  <div class="common-layout">
    <el-container>
      <el-header :class="ie?'el-header-ie':'el-header-common'">
        <img src="../assets/sheca_logo.png" alt="sheca-logo" />
        <el-link class="text" type="primary" @click="gotontsc">{{ form.time }}(UTC+08:00)</el-link>
      </el-header>
      <el-main>
        <div class="title">欢迎使用上海CA可信时间戳验证服务</div>
        <el-card class="box-card">
          <div class="card-title">
            <img src="../assets/logo3.png" alt="logo3" />
            <div>可信时间戳验证</div>
          </div>
          <!-- <div class="card-text">
            <span class="text-blue"
              >本页面只针对上海市数字证书认证中心有限公司提供的时间戳服务提供验证，</span
            >
            本公司不对时间戳业务过程中未采用本公司产品或服务过程的数据负责，本公司仅就数字证书签发过程及时间戳技术可靠性进行说明。
          </div> -->
          <div class="box1">
            <div class="text-yellow">
              本功能仅对上海CA提供的时间戳信息进行检验，验证结果仅供参考，不作为最终验证结论
            </div>
            <div class="box2">
              <el-tabs type="border-card" v-model="form.activeName" @tab-click="tabschange">
                <el-tab-pane label="签名值验证" name="first">
                  <el-form
                    ref="formRef"
                    :model="form"
                    class="demo-dynamic"
                    label-suffix=":"
                    size="large"
                    label-position="left"
                  >
                    <el-form-item
                      prop="tsRequest"
                      label="时间戳请求"
                      :rules="[
                        {
                          required: true,
                          message: '请输入时间戳请求',
                          trigger: 'blur'
                        }
                      ]"
                    >
                      <el-input
                        v-model="form.tsRequest"
                        :rows="3"
                        type="textarea"
                      />
                    </el-form-item>
                    <el-form-item
                      prop="tsResponse"
                      label="时间戳回包"
                      :rules="[
                        {
                          required: true,
                          message: '请输入时间戳回包',
                          trigger: 'blur'
                        }
                      ]"
                    >
                      <el-input
                        v-model="form.tsResponse"
                        :rows="3"
                        type="textarea"
                      />
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
                <el-tab-pane label="文件验证" name="second">
                  <input type="file" id="file" @change="fileChange" v-if="ie"/>                  
                  <el-upload
                    v-else
                    accept=".tsa"
                    ref="upload"
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    drag
                    :auto-upload="false"
                    :limit="1"
                    :on-remove="handleRemove"
                    :on-exceed="handleExceed"
                    :on-change="handleFileChange"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      将文件拖到此处，或<em>点击上传</em>
                    </div>
                    <template #tip>
                      <div class="el-upload__tip">提示：只支持上传.tsa文件</div>
                    </template>
                  </el-upload>
                </el-tab-pane>
              </el-tabs>
              <div>
                <div class="slider-verification-box">
                  <div class="verification-text">请滑动模块来验证:</div>
                  <div id="nc"></div>
                </div>
                <div class="image-verification-box">
                  <div class="verification-text">请输入图形验证码:</div>
                  <div style="display: flex">
                    <el-input
                      class="verification-input"
                      v-model="form.ImageIdCode"
                    />
                    <el-image
                      style="width: 150px; height: 50px"
                      @click="getimg"
                      :src="form.pictureValue"
                      fit="fill"
                    ></el-image>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="button-box">
            <el-button size="large" @click="resetForm()">重置</el-button>
            <el-button
              size="large"
              type="primary"
              @click="submitForm()"
              :loading="config.comfirmLoad"
              >验证</el-button
            >
          </div>
        </el-card>
      </el-main>
    </el-container>
    <div class="el-login-footer">
      <span>Copyright 1999-2023 © 上海市数字证书认证中心有限公司</span>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import moment from "moment";
import { getTimeStamp, getTSACode, codeVerify, TSAVerify } from "../api/index";
export default {
  data: function() {
    return {
      form: {
        activeName: "first", //选中的标签页
        tsRequest: "", //时间戳请求
        tsResponse: "", //时间戳回包
        filetsRequest: "", //文件时间戳请求
        filetsResponse: "", //文件时间戳回包
        time: "", //校准之后的时间
        timeOffset: 0, //时间差
        pictureKey: "", //图形验证码key
        pictureValue: "", //图形验证码base64
        ImageIdCode: "", //图形验证码数字
        SliderIdCode: false //是否进行滑动验证
      },
      config: {
        comfirmLoad: false
      }
    };
  },
  computed:{
    ie(){
      if(document.documentMode && document.documentMode == 9){return true}
      return false
    }
  },
  mounted() {
    this.verifyInit();
    this.getimg();
    this.getTime();
    this.updatetime();
  },
  methods: {
    //获取标准时间
    async getTime() {
      // if(this.ie){
      //   $.get('/tsa/timestamp?time='+ new Date().getTime(), {
      //   }, function (res) {
      //     console.log(res,'有没有')
      //   });
      //   return 
      // }
      try {
        const res = await getTimeStamp();
        if (res.code == 0) {
          console.log(res, "标准时间");
          var standardTime = moment(res.data).valueOf();
          var currentTime = Number(moment().format("x"));
          this.form.timeOffset = standardTime - currentTime;
          console.log(
            standardTime,
            currentTime,
            this.form.timeOffset,
            "标准时间，本地时间，时间差"
          );
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    //更新时间
    updatetime() {
      var _this = this
      setInterval(function() {
        var currentTime = Number(moment().format("x"));
        var time = currentTime + _this.form.timeOffset;
        _this.form.time = moment(time).format("YYYY-MM-DD HH:mm:ss:SSS");
      }, 1);
    },
    //获取图形验证码
    async getimg() {
      // if(this.ie){
      //   $.get('/tsa/code?time='+ new Date().getTime(), {
      //   }, function (res) {
      //     if (res.code == 0) {
      //       this.form.pictureKey = res.data.pictureKey;
      //       this.form.pictureValue = res.data.pictureValue;
      //       console.log(this.form.pictureKey, this.form.pictureValue, "图形验证码");
      //     }
      //   });
      //   return 
      // }
      try {
        const res = await getTSACode();
        if (res.code == 0) {
          this.form.pictureKey = res.data.pictureKey;
          this.form.pictureValue = res.data.pictureValue;
          console.log(this.form.pictureKey, this.form.pictureValue, "图形验证码");
        }
      } catch (err) {
        alert(err.message)
        this.$message.error(err.message);
      }
    },

    verifyInit() {
      var _this = this
      // 实例化nc
      window.AWSC.use("nc", function(state, module) {
        // 初始化
        window.nc = module.init({
          // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
          appkey: "CF_APP_1",
          //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
          scene: "register",
          // 声明滑动验证需要渲染的目标ID。
          renderTo: "nc",
          //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
          success: function(data) {
            _this.form.SliderIdCode = true;
            window.console && console.log(data.sessionId);
            window.console && console.log(data.sig);
            window.console && console.log(data.token);
          },
          // 滑动验证失败时触发该回调参数。
          fail: function(failCode) {
            window.console && console.log(failCode);
          },
          // 验证码加载出现异常时触发该回调参数。
          error: function(errorCode) {
            window.console && console.log(errorCode);
          }
        });
      });
    },

    handleFileChange(file) {
      var _this = this
      var type = file.name.split(".").slice(-1)[0].toLowerCase();
      if (type !== "tsa") {
        this.$refs.upload.clearFiles();
        return this.$message.warning("只支持上传.tsa文件");
      }
      if(file.size == 0){
        this.form.filetsRequest = "";
        this.form.filetsResponse = "";
      }
      var reader = new FileReader();
      reader.onload = function() {
        if (reader.result) {
          var str = reader.result;
          console.log(str, "文件的string");
          var arr = str.split(/[\n]/);
          console.log(arr, "文件的BASE64");
          _this.form.filetsRequest = arr[0] || "";
          _this.form.filetsResponse = arr[1] || "";
        }
      };
      reader.readAsText(file.raw);
    },

    handleExceed(files) {
      this.$refs.upload.clearFiles();
      const file = files[0];
      this.$refs.upload.handleStart(file);
    },

    handleRemove(file, uploadFiles) {
      this.form.filetsRequest = "";
      this.form.filetsResponse = "";
    },

    fileChange() {
      if(this.ie){
        var ActiObj = new ActiveXObject("Scripting.FileSystemObject");
        var url=  document.getElementById('file').value;
        var file = ActiObj.OpenTextFile(url, 1);//文件路径
        var txt = file.ReadAll();
        console.log('123123')
        console.log(txt)
        var arr = txt.split(/[\s\n]/);
        this.form.filetsRequest = arr[0] || "";
        this.form.filetsResponse = arr[2] || "";
      }
    },

    //验证时间戳
    async submitForm() {
      if (this.form.activeName == "first") {
        this.$refs.formRef.validate(async (valid) => {
          if (valid) {
            this.verify(this.form.tsRequest, this.form.tsResponse);
          }
        });
      } else if (this.form.activeName == "second") {
        if (this.form.filetsRequest == "" || this.form.filetsResponse == "") {
          return this.$message.warning("文件为空或文件格式错误");
        }
        this.verify(this.form.filetsRequest, this.form.filetsResponse);
      }
    },

    async verify(tsRequest, tsResponse) {
      this.config.comfirmLoad = true;
      if (!this.form.SliderIdCode) {
        this.$message.warning("请进行滑动验证");
        return (this.config.comfirmLoad = false);
      }
      if (!(await this.imgCodeVerify())) {
        return (this.config.comfirmLoad = false);
      }
      try {
        const res = await TSAVerify({ tsRequest, tsResponse });
        if (res.code == 0) {
          this.$confirm("验证成功", "提示", {
            confirmButtonText: "确定",
            showCancelButton: false,
            type: "success"
          });
        }
      } catch (err) {
        this.$confirm("验证失败，请核查信息来源", "提示", {
          confirmButtonText: "确定",
          showCancelButton: false,
          type: "error"
        });
      } finally {
        this.config.comfirmLoad = false;
      }
    },

    //重置
    resetForm() {
      if(this.ie){
        var test =  document.getElementById('file')
        test.outerHTML = test.outerHTML; 	
      }else{
        this.$refs.upload.clearFiles();        
      }
      window.nc["reset"]();
      this.$refs.formRef.resetFields();
      this.form.filetsRequest = "";
      this.form.filetsResponse = "";

      this.form.ImageIdCode = "";
      this.form.SliderIdCode = false;
      this.getimg();
    },
    //验证图形验证码
    async imgCodeVerify() {
      if (this.form.ImageIdCode == "") {
        this.$message.warning("请输入图形验证码");
        return false;
      }
      try {
        const res = await codeVerify({
          pictureKey: this.form.pictureKey,
          pictureValue: this.form.ImageIdCode
        });
        if (res.code == 0) {
          return true;
        }
      } catch (err) {
        this.getimg();
        this.$message.error(err.message);
      }
    },

    gotontsc() {
      window.open("http://www.ntsc.ac.cn/");
    },

    tabschange(){
      window.nc["reset"]();
      this.form.ImageIdCode = "";
      this.form.SliderIdCode = false;
      this.getimg();
    }
  }
};
</script>

<style scoped>
.upload-demo ::v-deep .el-upload--text{
  width: 100% !important;
}
.upload-demo ::v-deep .el-upload {
  width: 100% !important;
}
.upload-demo ::v-deep .el-upload-dragger {
  width: 100% !important;
}
.upload-demo{
  text-align: center;
}
.el-header-common {
  background: linear-gradient(#8cb1f6, #487ff3);
  display: flex;
  color: #fff;
  justify-content: space-around;
  align-items: center;
  padding: 0;
}
.el-header-ie {
  background:#487ff3;
  display: flex;
  color: #fff;
  justify-content: space-around;
  align-items: center;
  padding: 0;
}
  .text {
    font-size: medium;
    width: 500px;
    color: #fff !important;
  }
.el-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f6fafd;
  padding: 0px !important;



}
  .title {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: larger;
    color: #a1a9c8;
    background-color: #fff;
  }
  .box-card {
    background: linear-gradient(#cddbf7, #fff);
    width: 80%;
    margin: 20px;
    padding: 20px;
  }
  .card-title {
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: xx-large;
      font-weight: bold;
      color: #6274c5;
      margin-bottom: 20px;
    }
 .card-text {
      margin: 10px;
      font-size: small;
      margin-bottom: 30px;
    }
.text-blue {
      color: #0000ff;
    }
 .box1 {
      background-color: #fff;
      padding: 20px;
     
    }

 .text-yellow {
        color: #f6ad61;
        margin: 20px;
      }
 .box2 {
      display: flex;
      
    }
.el-tabs {
        width: 50%;
        margin: 10px;
      }
 #nc {
      width: 400px !important;
    }
.verification-text {
      font-size: small;
      margin-bottom: 10px;
    }
.slider-verification-box {
      margin: 40px 60px;
      /* margin: 20px 60px; */
    }
    .image-verification-box {
      margin: 90px 60px 10px 60px;
      /* margin: 70px 60px 10px 60px; */
    }
      .verification-input {
        height: 50px;
        width: 150px;
        margin-right: 10px;
      }
    .button-box {
      text-align: center;
      margin-top: 20px;
    }
.el-login-footer {
  height: 40px;
  line-height: 40px;
  /* position: fixed; */
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #d8dbe0;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue